import { Injectable } from '@angular/core';
import { CanActivate, CanMatch, Route, Router, UrlSegment, UrlTree } from '@angular/router';

import { AuthService } from '../services/auth.service';

@Injectable({ providedIn: 'root' })
export class UserDashboardOnlyGuard implements CanMatch, CanActivate {
  constructor(
    private readonly auth: AuthService,
    private readonly router: Router,
  ) {}

  canMatch(_route: Route, _segments: UrlSegment[]): boolean | UrlTree {
    return this.check();
  }

  canActivate(): boolean | UrlTree {
    return this.check();
  }

  private check(): boolean | UrlTree {
    if (!this.auth.isUser) return true;
    return this.router.parseUrl('/monitoramento');
  }
}
